import {
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'

import { getErrorMessage } from '@/shared/lib'
import { request } from '@/api/apiClient'
import { Profile } from '@/shared/store/useAppStore'
import { ILoginAndProfileService } from '@/shared/types/services/types/loginAndProfile/loginAndProfileTypes'
import {
    checkPINRoute,
    getProfilesRoute,
    setProfileRoute,
} from '@/api/toya/apiConstantsCodespot'

class LoginAndProfileService implements ILoginAndProfileService {
    fetchProfiles = async () => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        try {
            const { jsonData: response } = await request(
                'GET',
                getProfilesRoute,
                sessionToken,
                true
            )

            if (response && Array.isArray(response)) {
                return response
            } else {
                throw new Error('Invalid response format')
            }
        } catch (error) {
            getErrorMessage('Error fetching profiles:', error)
            throw error
        }
    }

    checkPin = async (pin: number, id: string) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const route = `${checkPINRoute}/${pin}`
        const requestHeader = {
            'User-Profile-Id': id,
        }
        try {
            const { jsonData: response } = await request(
                'POST',
                route,
                sessionToken,
                true,
                undefined,
                id,
                requestHeader
            )

            if (response) return response.message
        } catch (error) {
            getErrorMessage('Error check pin:', error)
            throw error
        }
    }

    setProfile = async (profile: {
        version: number
        profile_name: string
        isKid: boolean
        order: string
        iconId: string
    }) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)

        try {
            await request(
                'POST',
                setProfileRoute,
                sessionToken,
                true,
                JSON.stringify(profile)
            )
        } catch (error) {
            getErrorMessage('Error set profiles:', error)
            throw error
        }
    }
    deleteProfile = async (id: string) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const route = `${setProfileRoute}/${id}`
        const requestHeader = {
            'User-Profile-Id': id,
        }
        try {
            await request(
                'DELETE',
                route,
                sessionToken,
                true,
                undefined,
                id,
                requestHeader
            )
        } catch (error) {
            getErrorMessage('Error delete profiles:', error)
            throw error
        }
    }

    updateProfile = async (profile: Profile) => {
        const sessionToken = getFromLocalStorage(sessionTokenLsKeyword)
        const { id, ...otherProps } = profile
        const route = `${setProfileRoute}/${id}`
        const requestHeader = {
            'User-Profile-Id': id,
        }
        try {
            const response = await request(
                'PUT',
                route,
                sessionToken,
                true,
                JSON.stringify(otherProps),
                id,
                requestHeader
            )
            if (response) {
                return true
            } else {
                throw new Error('Invalid response format')
            }
        } catch (error) {
            getErrorMessage('Error update profiles:', error)
            return false
        }
    }
}

export default new LoginAndProfileService()
